import React, { useState } from 'react';

import styled from '@emotion/styled';

import SettingsIcon from '../../../components/Icons/SettingsIcon';
import TrendUpIcon from '../../../components/Icons/TrendUpIcon';
import { Modal } from '../../../components/Modal/Modal';
import PerformanceBenchmarkModal from '../../../components/Modal/ModalActions/PerformanceBenchmarkModal/PerformanceBenchmarkModal';
import RatingThresholdModal from '../../../components/Modal/ModalActions/RatingThresholdModal/RatingThresholdModal';
import TopTierBenchmarkModal from '../../../components/Modal/ModalActions/TopTierBenchmarkModal/TopTierBenchmarkModal';

const PerformanceMonitoringHeaders = () => {
  const [showBenchmarkModal, setShowBenchmarkModal] = useState(false);
  const [showTopTierModal, setShowTopTierModal] = useState(false);
  const [showRatingThresholdModal, setShowRatingThresholdModal] =
    useState(false);

  return (
    <Container>
      <TextArea>
        <Header>Performance Monitoring</Header>
        <Description>
          Monitor and manage company performance benchmarks and tiers
        </Description>
      </TextArea>

      <ButtonArea>
        <Button onClick={() => setShowBenchmarkModal(true)}>
          <TrendUpIcon /> Set Benchmark
        </Button>
        <Button onClick={() => setShowTopTierModal(true)}>
          <SettingsIcon /> Tier Setup
        </Button>
        {/* <Button
          onClick={() => setShowRatingThresholdModal(true)}
          className='blue'
        >
          Rating Threshold
        </Button> */}
      </ButtonArea>

      <Modal
        showModal={showBenchmarkModal}
        setShowModal={setShowBenchmarkModal}
      >
        <PerformanceBenchmarkModal />
      </Modal>
      <Modal showModal={showTopTierModal} setShowModal={setShowTopTierModal}>
        <TopTierBenchmarkModal />
      </Modal>
      <Modal
        showModal={showRatingThresholdModal}
        setShowModal={setShowRatingThresholdModal}
      >
        <RatingThresholdModal />
      </Modal>
    </Container>
  );
};

export default PerformanceMonitoringHeaders;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  /* border: 1px solid red; */
  align-items: center;
  justify-content: space-between;
`;

const ButtonArea = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-direction: row;
`;

const TextArea = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`;

const Header = styled.div`
  font-weight: 600;
  font-size: 22px;
  line-height: 22px;
  color: #232222;
`;

const Description = styled.div`
  font-weight: 400;
  line-height: 14px;
  font-size: 14px;
  color: #6b7280;
`;

const Button = styled.button`
  display: flex;
  cursor: pointer;
  align-items: center;
  gap: 8px;
  border: 1px solid ${({ theme }) => theme.palette.blueColor};
  background-color: white;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  color: ${({ theme }) => theme.palette.blueColor};

  &.blue {
    color: white;
    background: linear-gradient(
      262.94deg,
      #436db8 9.61%,
      #5b91f5 49.28%,
      #3c80ff 85.91%
    );
    padding: 14px 16px;
    border: none;
  }

  & > svg {
    color: ${({ theme }) => theme.palette.blueColor} !important;
  }
`;
